import { TellescopeModelFromName } from "@tellescope/tanstack-query";

type Block = TellescopeModelFromName<"custom_dashboards">["blocks"][number];

export interface VisibleBlock {
  block: Block;
  index: number;
}

export interface ReorderVisibleBlocksArgs {
  blocks: Block[];
  visibleBlocks: VisibleBlock[];
  activeId: string;
  overId: string;
}

export const getBlockSortableId = (block: Block, index: number): string => block.info?.id ?? `${block.type}-${index}`;

export const reorderVisibleBlocks = ({
  blocks,
  visibleBlocks,
  activeId,
  overId,
}: ReorderVisibleBlocksArgs): Block[] => {
  const from = visibleBlocks.findIndex(({ block, index }) => getBlockSortableId(block, index) === activeId);
  const to = visibleBlocks.findIndex(({ block, index }) => getBlockSortableId(block, index) === overId);

  if (from === -1 || to === -1 || from === to) return blocks;

  const dragged = visibleBlocks[from];
  if (!dragged) return blocks;

  const withoutDragged = visibleBlocks.filter((_, slot) => slot !== from);
  const reordered = [
    ...withoutDragged.slice(0, to).map(({ block }) => block),
    dragged.block,
    ...withoutDragged.slice(to).map(({ block }) => block),
  ];

  const next = [...blocks];
  visibleBlocks.forEach(({ index }, slot) => {
    const block = reordered[slot];
    if (block) next[index] = block;
  });

  return next;
};
